import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/firm';
import { api } from 'lib/httpClient';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';
import { useNotification } from 'hooks/ui/useNotification';
import useApiExceptionHandler from 'hooks/ui/useApiExceptionHandler';

export function useDeleteFirm() {
  const queryClient = useQueryClient();
  const notification = useNotification();
  const handleApiException = useApiExceptionHandler();
  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await api.delete<ApiResponse>(`firm/${id}`);
      return data;
    },
    onSuccess: (data) => {
      notification.success(data?.responseMsg ?? '');
      queryClient.invalidateQueries({ queryKey: ['firms'] });
    },
    onError: (error) => {
      handleApiException(error);
    },
  });
}

export function useFirm({
  params,
}: {
  params: Api.GetFirmListRequestQuery & {
    disabled?: boolean;
  };
}) {
  const firms = useQuery({
    queryKey: ['firms', { ...params }],
    queryFn: async () => {
      const { data } = await api.get<ApiResponse<Api.GetFirmListResponse>>(
        'firm',
        { params },
      );

      return data.data;
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
    enabled: !params.disabled,
  });

  return {
    firms,
  };
}
